const StudentsTableTemp = ({ data }) => {
    return ( 
        <table className="mt-4">
            <thead>
                 <tr>
                    <th>Name</th>
                    <th className="hide-on-small-only">Date Of Birth</th>
                    <th className="hide-on-small-only">Gender</th>
                    <th className="hide-on-small-only">ID No.</th>
                    <th>Class</th>
                    <th>Email</th>
                </tr>
            </thead>
            <tbody>  
                {
                    data.length !== 0 && data.map(item => (
                        <tr key={item.idNumber}>
                            <td>{item.title} {item.forenames} {item.surname}</td>
                            <td className="hide-on-small-only">{item.dob}</td>    
                            <td className="hide-on-small-only">{item.gender}</td>    
                            <td className="hide-on-small-only">{item.idNumber}</td>    
                            <td>{item.programme}</td> 
                            <td>{item.email}</td>
                        </tr>
                    ))
                }
            </tbody>
        </table>
     );
}
 
export default StudentsTableTemp;